import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { api, type DepositView } from '../api';
import { CopyText, Header, Notice, WalletId } from '../components/ui';

export function DepositPage({ walletId }: { walletId?: string }) {
  const [data, setData] = useState<DepositView | null>(null);
  const [qr, setQr] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    api.deposit().then(async result => {
      const image = await QRCode.toDataURL(result.qrPayload, { width: 320, margin: 2, errorCorrectionLevel: 'M' });
      if (active) { setData(result); setQr(image); }
    }).catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, []);
  return <div className="app"><Header title="充值" />{walletId && <WalletId id={walletId} />}
    <div className="body deposit-body">
      <div className="network-label"><span className="coin-mark">₮</span><div><strong>USDT 充值</strong><small>TRON · TRC20 网络</small></div><span className="badge success">专属地址</span></div>
      {error ? <div className="error" role="alert">{error}</div> : !data ? <div className="loading">正在获取您的充值地址…</div> : <>
        {data.notice && <Notice>{data.notice}</Notice>}
        <div className="qr-card"><img src={qr} width="256" height="256" alt="您的 USDT-TRC20 专属充值地址二维码" /><p>扫描二维码向钱包充值</p></div>
        <section className="address-card"><h2>我的专属充值地址</h2><CopyText value={data.address} /><p>此地址长期有效，仅归属您的钱包。</p></section>
        <Notice>仅支持 USDT-TRC20。请核对网络和地址，链上确认后自动计入余额。</Notice>
        <a className="ghost button-link" href="#/bills">查看充值记录</a>
      </>}
    </div></div>;
}
